<template>
  <div>
    <div class="page--section">
      <h2>{{ $t('favoritesHeading') }}</h2>
      <el-row :gutter="gutter">
        <el-col :xs="xs" :sm="sm" :md="md" v-for="product in currentUser.favoriteProducts" :key="product">
          <product-card :product-id="Number(product)"></product-card>
        </el-col>
      </el-row>

      <div v-if="!currentUser.favoriteProducts || (currentUser.favoriteProducts.length === 0)"
        class="placeholder__favorite">
        <span class="placeholder__title">{{ $t('favoritesPlaceholderTitle') }}</span>
        <span class="placeholder__subtitle">{{ $t('favoritesPlaceholderSubtitle') }}</span>
      </div>

    </div>
  </div>
</template>

<script>
import ProductCard from './products/ProductCard.vue';
import user from './user';
import { mapState } from 'vuex';

export default {
  name: 'FavoritesComp',
  computed: {
    ...mapState(user.store.namespace, [
      'currentUser'
    ])
  },
  components: {
    ProductCard
  },
  props: {
    gutter: {
      type: Number
    },
    xs: {
      type: Number
    },
    sm: {
      type: Number
    },
    md: {
      type: Number
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/base/_variables.scss';

.placeholder {

  &__favorite {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: center;
    text-align: center;
    border: 5px dashed #000000;
    border-radius: 16px;
    padding: 40px 0;
    margin: 16px 0;
    opacity: .18;
  }

  &__title {
    font-size: 26px;
    font-weight: 900;
    line-height: 1.2;
    text-transform: uppercase;
    letter-spacing: $--serif-letter-spacing;
    margin: 0 10px 4px;
  }

  &__subtitle {
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: $--sans-letter-spacing;
    margin: 0 10px;
  }
}
</style>
